import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Card, CardHeader, CardBody, CardFooter, Collapse, Tooltip } from 'reactstrap';
import { Checkbox, Radio, Switch } from 'pretty-checkbox-react';

import Users from '../users/Users';

const LIVESC_NBOF_DATACOL = 5;
const PAGER_DISPPAGES = 4;
const PAGER_PAGESIZE = 10;

const SS_STATUS_TRANSLATION = [
	{ en: "Scheduled", fr: "À l'horaire" },
	{ en: "Pending approval", fr: "En approbation" },
	{ en: "Validated", fr: "Validée" }
]

class LiveScoresheets extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			isAuthenticated: false,
			playerId: "0",

			season: {name: ''},

			resultTableData: [],

			dataFilters: {
				filteredResults: false,
				filterPlayerId: false,
				unplayedMatchs: false
			},

			sortFieldIdx: 0,
			sortOrder: 'asc',
			sortClass: [],

			pager: {
				startIndex: 0,
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				endIndex: PAGER_PAGESIZE-1,
				totalItems: 0
			},
			loading: true
		};
	
		this.createTableRow = this.createTableRow.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
		this.handlePlayerFilterChange = this.handlePlayerFilterChange.bind(this);
		this.handleUnplayedFilterChange = this.handleUnplayedFilterChange.bind(this);
		this.handleEditScoresheetClick = this.handleEditScoresheetClick.bind(this);

		this.getConnectedUserInfo = this.getConnectedUserInfo.bind(this);
}

	componentDidMount() {
		this.initiateModuleAndUser();
	}

/*
  componentDidUpdate(prevProps) {
  	console.log('LiveScoresheets: componentDidUpdate')
  	console.log(this.props)

    var seasonId = this.props.match.params.seasonid;
		if (this.props.season._id !== prevProps.season._id) {
			this.initiatePagerSizeWithData(seasonId);
	  }
  }
*/

	initiateModuleAndUser() {
    //console.log('LiveScoresheets: initiateModuleAndUser');
		var _this = this;

		var sortClass = ['asc'];
		for(var i = 1; i < (LIVESC_NBOF_DATACOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[this.state.sortFieldIdx] = "statelo-sorting_" + this.state.sortOrder;

		this.getConnectedUserInfo(function(isAuthenticated, playerId) {
			//console.log('getConnectedUserInfo')
			//console.log(isAuthenticated, playerId)

			_this.setState({
				isAuthenticated: isAuthenticated,
				playerId: playerId,
				sortClass: sortClass,
	      loading: true,
			}, 
				_this.initiatePagerSizeWithData(_this.state.dataFilters, true)
			);
		});
	}

	initiatePagerSizeWithData(dataFilters, resetSorting) {
    //console.log('LiveScoresheets: initiatePagerSizeWithData');
		var _this = this;
		var seasonId = this.props.match.params.seasonid;
		var status = dataFilters.unplayedMatchs ? "Scheduled" : "None";

		// ### SET filter for filterPlayerId
		// faire un peu de ménage dans la logique de filtre
		// status, playerId, actif ou pas, etc...

		Axios.get('/api/scheduledMatchs/pagesort/size' + 
			'/seasonId/' + seasonId +
			'/playerId/' + this.state.playerId + '/' + dataFilters.filterPlayerId + 
			'/status/' + status).then(function(responseScheduledMatchs) {

			// Init pager
			var pager = {
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				startindex: 0,
				endIndex: PAGER_PAGESIZE-1,
				totalItems: responseScheduledMatchs.data.count,
			};

			_this.setPage(1, pager);
		});

	}

  setPage(page, pager) {
    // console.log('LiveScoresheets: setPage');
  	// set optional parameters
    var pager = pager || this.state.pager;

    if (page < 1 || page > pager.totalPages) {
    	console.log('************ ERR *************');
    	console.log('setPage unexpected return');
    	return;
    }

    // get new pager object for specified page
    pager = this.getPager(pager.totalItems, page);

    // call change page function in parent component
    this.loadData(pager, this.state.sortFieldIdx, this.state.sortOrder);
  }

	getPager(totalItems, currentPage, pageSize) {

	  // default to first page
	  currentPage = currentPage || 1;

	  // default page size is 10
	  pageSize = pageSize || PAGER_PAGESIZE;

	  // calculate total pages
	  var totalPages = Math.ceil(totalItems / pageSize);

	  var startPage, endPage;
	  if (totalPages <= PAGER_DISPPAGES) {
	      // less than 10 total pages so show all
	      startPage = 1;
	      endPage = totalPages;
	  } else {
	      // more than 10 total pages so calculate start and end pages
	      if (currentPage <= ((PAGER_DISPPAGES / 2) + 1)) {
	          startPage = 1;
	          endPage = PAGER_DISPPAGES;
	      } else if (currentPage + ((PAGER_DISPPAGES / 2) - 1) >= totalPages) {
	          startPage = totalPages - (PAGER_DISPPAGES - 1);
	          endPage = totalPages;
	      } else {
	          startPage = currentPage - Math.ceil(PAGER_DISPPAGES / 2);
	          endPage = currentPage + Math.ceil((PAGER_DISPPAGES / 2) - 1);
	      }
	  }

	  // calculate start and end item indexes
	  var startIndex = (currentPage - 1) * pageSize;
	  var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

	  // create an array of pages to ng-repeat in the pager control
	  // var pages = _.range(startPage, endPage + 1);		// lodash function
		var pages = Array.apply(0, Array(endPage - startPage + 1)).map(function (element, index) { 
    	return index + startPage;  
  	});
    
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

	loadData(pager, sortFieldIdx, sortOrder) {
		console.log('LiveScoresheets - loadData');

		var _this = this;
		document.body.classList.add('busy-cursor');

    var seasonId = this.props.match.params.seasonid;
		var dataFilters = this.state.dataFilters;
		var playerId = this.state.playerId;

    Axios.get('/api/seasons/' + seasonId).then(function (responseSeason) {

		// ### ADD unplayedMatchs consideration
		var status = dataFilters.unplayedMatchs ? "Scheduled" : "None";

		// ### SET filter for filterPlayerId
		Axios.get('/api/scheduledMatchs/pagesort/seasonId/' + seasonId + 
			'/playerId/' + playerId + '/' + dataFilters.filterPlayerId + '/status/' + status +
			'/start/' + pager.startIndex + '/end/' + (pager.endIndex + 1) + 
			'/sortFieldIdx/' + sortFieldIdx + '/sortOrder/' + sortOrder).
			then(function(responseScheduledMatchs ) {

				// console.log('response.data');
				// console.log(response.data);
				_this.setState({
					season: responseSeason.data.season,
					pager: pager,
					resultTableData: responseScheduledMatchs.data,
					loading: false
				});

				document.body.classList.remove('busy-cursor');
		});
		});
	}

 	render() {
		console.log('LiveScoresheets: render');
		//console.log(this.state);

    var pager = this.state.pager;
		var bDispModule = true;
    if (pager.pages.length < 1) {
    	bDispModule = false;
    } 

		return (
			<div className="animated fadeIn row-margin-bottom-100">

				<div className="row">
				<div className="col-md-12">
					<h4>FEUILLES DE POINTAGE</h4>
					<p><strong>{this.state.season.name}</strong></p>

					{/*<h4>INSTRUCTIONS</h4>*/}
        	<ul className="ul-left-aligned">
        		<li>Vous devez être connecté...</li>
		        	<ul className="ul-left-aligned">
    	    			<li>pour filtrer avec vos matchs seulement</li>
      		  		<li>pour remplir une feuille de nmatch</li>
        	</ul>
        	<li>Ligne d'instructions avec quelques explications</li>
        	</ul>

				</div>
				</div>
				<hr/>

				<div className="row">
				<div className="col-12">
					<strong className="font-weight-bold">FILTRES</strong>

					<div className="row margin-top-10">
		      <div className="col-12">
						<Checkbox color="success" animation="pulse" shape="curve" checked={(this.state.dataFilters.filterPlayerId || false)} 
							disabled={!this.state.isAuthenticated} onChange={this.handlePlayerFilterChange}> Mes matchs seulement </Checkbox>
						<Checkbox color="success" animation="pulse" shape="curve" checked={(this.state.dataFilters.unplayedMatchs || false)} 
							onChange={this.handleUnplayedFilterChange}> Matchs non-joués seulement</Checkbox>
					</div>
					</div>
				</div>
				</div>

				<hr/>

				<div className="row">
        <div className="col-12">
        	<h5>MATCHS CÉDULÉS</h5>
				</div>
				</div>

				<div className="row">
				<div className="col-md-12">

					{bDispModule ? this.displayModule(pager) : 
						<div>
						<p>Aucun match cédulée</p>
						</div>
					}
				</div>
				</div>
{/*
				<hr className="hrThick"/>
*/}
			</div>
		);
	}

	displayModule(pager) {
		if (this.state.loading) {
			return (
				<div className="text-center margin-top-10">
					<i> données en chargement </i>
					{this.displaySpinner()}
				</div>
			);
		} else {
			return ( this.displayData(pager) );
		}
	}

	displayData(pager) {
		var sortClass = this.state.sortClass;

		var bDispPagination = true;
    if (pager.pages.length < 2) {
			bDispPagination = false;
		}

		return (
     	<div className="row">
     	<div className="col-12">

			<p>{pager.totalItems} matchs</p>

			{this.state.dataFilters.filteredResults ? 
				<strong>(résultats filtrés)</strong> : null}
			
			<div className="table-responsive">
			<table className="table table-striped table-hover table-sm">
			<thead>
				<tr>
				<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable} > Date </th>
				<th id='hdr.1' className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable} > Sous-saison	</th>
				<th id='hdr.2' className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable} > Prog.	</th>
				<th id='hdr.3' className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable} > Lieu </th>
				<th id='hdr.4' className={"statelo-sorting " + sortClass[4]} onClick={this.handleSortTable} > Équipe A </th>
				<th id='hdr.5' className={"statelo-sorting " + sortClass[5]} onClick={this.handleSortTable} > Équipe B </th>
				<th id='hdr.6' className={"statelo-sorting " + sortClass[6]} onClick={this.handleSortTable} > Format </th>
				<th id='hdr.7' className={"statelo-sorting " + sortClass[7]} onClick={this.handleSortTable} > Statut </th>
				<th id='hdr.8'></th>
				</tr>
			</thead>

			<tbody>
				{this.state.resultTableData.map(this.createTableRow)}
			</tbody>
			</table>
			</div>

			{bDispPagination ? this.displayPagination(pager) : null}
			</div>
			</div>
		);
	}

	displayPagination(pager) {
		return (
      <ul className="pagination">
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(1)}>{"<<"}</a>
        </li>
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage - 1)}>{"<"}</a>
        </li>
        {pager.pages.map((page, index) =>
          <li key={index} className={pager.currentPage === page ? 'active' : ''}>
              <a onClick={() => this.setPage(page)}>{page}</a>
          </li>
        )}
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage + 1)}>{">"}</a>
        </li>
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.totalPages)}>{">>"}</a>
        </li>
      </ul>
		);
	}


	createTableRow(item, idx) {
  	var trClass = "stateloListItemPointer ";

  	// Status translation
  	var itemStatusFr = item.status;
  	SS_STATUS_TRANSLATION.forEach(sst => {
  		if (itemStatusFr === sst.en) {
  			itemStatusFr = sst.fr;
  		}
  	});

		return (
			<tr key={'te.' + idx}>
				<td>{moment(item.date).local().format("YYYY-MM-DD")}</td>
				<td>{item.subSeasonName}</td>
				<td>{item.week}</td>
				<td><a href={item.locationGooglemap} target="blank"><i className="fa fa-map-o"></i></a> &nbsp; {item.locationName}</td>

				{item.team1assigned ? 
					<td><strong>{item.team1Name}</strong></td> :
					<td>{item.team1Name}</td>}

				{item.team2assigned ? 
					<td><strong>{item.team2Name}</strong></td> :
					<td>{item.team2Name}</td>}

				<td>{item.scoresheetFormatId}</td>
				<td>{itemStatusFr}</td>
				<td>
					{((item.status === "Scheduled") && (item.assignedPlayerMatch)) ?
					<span className="btn-sm2 editIcon" onClick={this.handleEditScoresheetClick.bind(this, item)}>
        		<i className="fa fa-pencil-square-o"></i>
        	</span> : null}
			</td>
      </tr>
    );
	}

	handleSortTable(e) {
		var _this = this;
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var results = this.state.resultTableData;
		var sortOrder = this.state.sortOrder;
		var sortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			//if (colIdx === 2) {
				sortOrder = 'asc';
			//} else {
			//	sortOrder = 'desc';
			//}
		}

		var sortClass = [];
		for(var i = 0; i < (LIVESC_NBOF_DATACOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: colIdx,
			sortClass: sortClass
		});

		this.loadData(this.state.pager, colIdx, sortOrder);
	}

	handlePlayerFilterChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.filterPlayerId = e.target.checked;
		dataFilters.filteredResults = dataFilters.filterPlayerId || dataFilters.unplayedMatchs;

		this.setState({dataFilters: dataFilters});
    this.initiatePagerSizeWithData(dataFilters, false);
	}

	handleUnplayedFilterChange(e) {
		var dataFilters = this.state.dataFilters;
		dataFilters.unplayedMatchs = e.target.checked;
		dataFilters.filteredResults = dataFilters.filterPlayerId || dataFilters.unplayedMatchs;

		this.setState({dataFilters: dataFilters});
    this.initiatePagerSizeWithData(dataFilters, false);
	}

	handleEditScoresheetClick(item) {
		console.log('handleEditScoresheetClick');
		console.log(item)

		// Scoresheet

		const path = '/scoresheet/' + item._id;
		this.props.history.push(path);		

	}

	getConnectedUserInfo(callback) {
		var isAuthenticated = this.props.auth.isAuthenticated();
		var playerId = "0";

		if (isAuthenticated) {
			var profile = this.props.auth.getProfile();
			var authUserId = profile.user_id;
			Users.getUserInfo(authUserId, function(user) {
				playerId = user.playerId
				callback(isAuthenticated, playerId);
			});
		} else {
			callback(isAuthenticated, playerId);
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

}

export default LiveScoresheets;


